import * as React from 'react';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import StreetAddress, { StreetAddressViewModel } from '../StreetAddress';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type SchoolProps = RouteComponentProps<{
    schoolId: string
}>

type State = {
    isLoading: boolean;
    isDirty: boolean;
    Validation: boolean;

    school: SchoolData|undefined;
}

type SchoolData = {
    SchoolId: number;
    SchoolName: string;
    MainPhone: string;
    SchoolAddress: StreetAddressViewModel;
}

class School extends React.Component<SchoolProps, State> {
    constructor(props: SchoolProps) {
        super(props);

        this.state = {
            isLoading: true,
            isDirty: false,
            Validation: false,
            school: undefined,
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let schoolId = parseInt(this.props.match.params.schoolId) || 0;
        this.requestSchool(schoolId);
    }

    public componentWillReceiveProps(nextProps: SchoolProps) {
        // This method runs when incoming props (e.g., route params) change
        let schoolId = parseInt(nextProps.match.params.schoolId) || 0;

        if (this.state.school && this.state.school.SchoolId != schoolId) {
            this.requestSchool(schoolId);
        }
    }

    public render() {
        return <React.Fragment>
            {this.state.school &&
                <div className="k-form">
                    <DocumentTitle title={(!this.state.school.SchoolName) ? "New School" : this.state.school.SchoolName} />
                    <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                    {this.state.isLoading && <div className="k-loading-image"></div>}
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">School Name<div style={{ color: '#dc3545' }}>*</div></span>
                        </div>
                        <input
                            className="form-control"
                            type="text"
                            name={`SchoolName`}
                            placeholder="School Name"
                            value={this.state.school.SchoolName}
                            onChange={(e) => this.updateSchoolState({ SchoolName: e.target.value })}
                        />
                    </div>
                    <br />
                    <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">Main Phone Number</span>
                        </div>
                        <MaskedTextBox
                            mask="(000)000-0000"
                            name={`Phone`}
                            placeholder="(000)000-0000"
                            value={this.state.school.MainPhone || ''}
                            onChange={(e) => this.updateSchoolState({ MainPhone: e.target.value.replace(/_/g, "") })}
                        />
                    </div>
                    <br />
                    <StreetAddress
                        address={this.state.school.SchoolAddress}
                        onChange={(newAddress) => this.updateSchoolState({ SchoolAddress: newAddress })}
                        title="School Address"
                        validation={false}
                        />
                    <div className="text-right">
                        <LoadingButton 
                             onClick={this.save}
                             disabled={!this.state.isDirty}
                             isLoading={this.state.isLoading}
                             isLoadingText="Saving..."
                             className="btn btn-primary"
                        >
                            {this.state.school.SchoolId === 0 ? 'Create' : 'Save'}
                        </LoadingButton>
                    </div>
                </div>
            }
        </React.Fragment>;
    }

    private updateSchoolState(value: Partial<SchoolData>) {
        const school = Object.assign({}, this.state.school, value);
        this.setState({ school, isDirty: true });
    }

    private requestSchool(teacherId: number) {
        this.setState({ isLoading: true });
        fetchApi(`api/School/Get/${teacherId}`)
            .then((school: SchoolData) => {
                this.setState({ isLoading: false, isDirty: false, school: school });
            });
    }

    private save() {
        if (!this.state.school.SchoolName) {
            alert('A School name must be set');
            return;
        }

        this.setState({ isLoading: true, Validation: true}, () => {
            if (this.state.school && document.getElementsByClassName("error-msg").length === 0) {
                if (this.state.school.SchoolId > 0) {
                    fetchApi(`api/School/Save/${this.state.school.SchoolId}`, this.state.school, 'POST')
                        .then(() => {
                            this.setState({ isLoading: false, isDirty: false });
                        })
                        .catch(() => {
                            this.setState({ isLoading: false });
                            alert("Unable to save school!");
                        });
                } else {
                    fetchApi(`api/School/Create/`, this.state.school, 'POST')
                        .then((response: { SchoolID: number }) => {
                            this.updateSchoolState({ SchoolId: response.SchoolID });
                            this.setState({ isLoading: false, isDirty: false });

                            this.props.history.push("/schools");
                        })
                        .catch(() => {
                            this.setState({ isLoading: false });
                            alert("Unable to create school!");
                        })
                }
            }
        });
    }
}

export default School;
